import Wrapper from 'components/Wrapper';
import Text from 'components/Text';
import { Button } from 'components/ui/button';
import AuditsFunctional from './index.function';
import { fontSizes } from 'appconstants';
import { ReactSVG } from 'react-svg';
import { add_icon, search_icon } from 'asset/icons';
import { AuditModal, AuditTable } from './components';
import ConfirmModal from 'components/ConfirmModal';
import TablePagination from 'components/TablePagination';
import InputField from 'components/InputField';

const Audits = () => {
  const {
    audits,
    isModalOpen,
    modalMode,
    selectedAudit,
    handleCreate,
    handleEdit,
    setIsModalOpen,
    deleteModal,
    setDeleteModal,
    navigate,
    onPageChange,
    page,
    delete_loading,
    onPressDelete,
    onConfimDelete,
    search,
    onSearch
  } = AuditsFunctional();

  return (
    <Wrapper>
      <div className='flex items-center justify-between mb-6'>
        <div>
          <Text text='Manage Audits' className='font-bold' size={fontSizes.h26} />
          <Text text='Control and manage audits' className='text-muted-foreground' />
        </div>
        <Button variant='default' className='gap-2' onClick={handleCreate}>
          <ReactSVG src={add_icon} /> Create Audit
        </Button>
      </div>

      <div className='flex gap-3 mb-3 md:mb-5'>
        <InputField
          label='Search'
          value={search}
          placeholder={'Search'}
          onChange={onSearch}
          rightIcon={search_icon}
          className='md:w-1/3'
        />
      </div>

      <AuditTable audits={audits?.items} onEdit={handleEdit} onDelete={onPressDelete} onView={(audit) => navigate(`/audits/${audit.auditId}`)} />

      <TablePagination page={page} totalPages={audits?.totalPages ?? 0} onPageChange={onPageChange} />

      <AuditModal mode={modalMode} open={isModalOpen} onClose={() => setIsModalOpen(false)} audit={selectedAudit} onDone={onPageChange} />

      <ConfirmModal
        open={deleteModal}
        title='Delete Audit!'
        description='Are you sure you want to delete this audit?'
        confirmText='Yes'
        cancelText='No'
        onCancel={() => setDeleteModal(false)}
        onConfirm={onConfimDelete}
        loading={delete_loading}
      />
    </Wrapper>
  );
};

export default Audits;
